import React, { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import Dropdown from "react-bootstrap/Dropdown";
import { useNavigate, Link } from "react-router-dom";
import { getCategories } from "../services/categoryService";
import "../styles/Subheader.css";
import { IMAGE_BASE_URL } from "../api/api";

function Subheader() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getCategories();
        setCategories(data);
      } catch (error) {
        console.error("Error loading categories:", error);
      }
    };
    fetchCategories();
  }, []);

  const handleCategoryClick = (cat) => {
    navigate(`/category/${cat.id}`, { state: { category: cat } });
  };

  return (
    <nav className="navbar navbar-expand-lg sub-header">
      <div className="container">
        {/* All Categories Dropdown */}
        <Dropdown>
          <Dropdown.Toggle
            variant="light"
            id="categoriesDropdown"
            className="d-flex align-items-center"
          >
            <FaBars className="me-2" /> All Categories
          </Dropdown.Toggle>

          <Dropdown.Menu className="category-dropdown-menu">
            {categories.length > 0 ? (
              categories.map((cat) => (
                <Dropdown.Item
                  key={cat.id}
                  onClick={() => handleCategoryClick(cat)}
                  className="d-flex align-items-center category-dropdown-item"
                >
                  <img
                    src={`${IMAGE_BASE_URL}storage/${cat.image}`} // ✅ use global image URL
                    alt={cat.name}
                    className="dropdown-category-img me-2"
                  />
                  {cat.name}
                </Dropdown.Item>
              ))
            ) : (
              <Dropdown.Item disabled>Loading...</Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>

        {/* Other Navigation Links (Dynamic from API) */}
        <ul
          className="navbar-nav flex-row ms-4 d-none d-lg-flex"
          style={{ fontSize: "14px" }}
        >
          {categories.length > 0 ? (
            categories.slice(0, 9).map((cat) => (
              <li key={cat.id} className="nav-item me-2">
                <Link
                  className="nav-link navbar-link-custom"
                  to={`/category/${cat.id}`}
                  state={{ category: cat }}
                >
                  {cat.name}
                </Link>
              </li>
            ))
          ) : (
            Array.from({ length: 5 }).map((_, index) => (
              <li key={index} className="nav-item me-2">
                <span className="nav-link navbar-link-custom text-muted">
                  Loading...
                </span>
              </li>
            ))
          )}
        </ul>
      </div>
    </nav>
  );
}

export default Subheader;
